export const alertConstants = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    CLEAR: 'CLEAR'
};
